<label class="select-label">{{ label }} <sup *ngIf="required">*</sup></label>
<div class="select select-input" [ngClass]="{'invalid': invalid, 'no-formControlborder': noFormControlBorder}" 
    (click)="toggleDropdown()" #dropreference>
    <ul>
        <li *ngIf="!searchable" [class]="{'placeholder': !value && placeholder}">
            {{ !value ? placeholder : value.label }}
            <span class="icon icon-caret-down"></span>
        </li>
        <li *ngIf="searchable" class="search-container">
            <input 
                type="text" 
                [placeholder]="placeholder" 
                [(ngModel)]="searchTerm" 
                (input)="onSearchChange($event)"
                (click)="$event.stopPropagation(); showDropdown()"
                class="search-input">
            <span class="icon icon-caret-down"></span>
        </li>
    </ul>
    <app-select-dropdown [reference]="dropreference" #dropdown>
        <div class="select no-margin select-dropdown">
            <ul>
                <li class="hover" *ngFor="let option of filteredOptions" (click)="select(option)">{{ option.label }}</li>
            </ul>
        </div>
    </app-select-dropdown>
</div>
<div *ngIf="displayMessages" class="messages">
    <ng-content selector="app-form-error"></ng-content>
    <ng-content selector="app-form-success"></ng-content>
</div>